<template>
  <div class="order-detail-content">
    <div class="order-detail-item order-detail-status">
      <div class="order-detail-audit-status">
        <div class="color-black bold">
          订单审核状态：{{ orderDetail.status_name }}
        </div>
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        学员信息
      </div>
      <div class="order-detail-student">
        <div class="order-detail-people-name">
          <span class="order-detail-student-name">学员姓名： {{ orderDetail.nickname }}</span>
          <span>就读年级：{{ orderDetail.grade_name }}</span>
          <span>家长电话：{{ orderDetail.phone }}</span>
        </div>
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        退款套餐信息
      </div>
      <div v-for="(item,index) in orderDetail.orderInfo" :key="'orderInfo' + index" class="order-detail-package">
        <div>签约单号：{{ item.order_id }} 订单金额：{{ item.contract_amount }}</div>
        <div>课时信息：</div>
        <el-table :data="item.list">
          <el-table-column prop="summary" label="扣费方式" />
          <el-table-column prop="days" label="课时(天)" />
        </el-table>
        <div>退款金额: {{ item.refund_amount }}</div>
        <div>账务单号: {{ item.remark }}</div>
        <div>发票信息: {{ item.invoice_status }}</div>

      </div>

    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        退款信息
      </div>
      <div class="order-detail-package">
        <div>总退款金额: {{ orderDetail.amount }}</div>
        <div v-if="orderDetail.payment">
          备注信息：{{ orderDetail.remark }}
        </div>
        <div v-if="orderDetail.remark">
          财务单号：{{ orderDetail.out_trade_no }}
        </div>
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        挽单信息
      </div>
      <div class="order-detail-package">
        <div v-if="orderDetail.extra.refundReason">
          退款过程及原因分析：{{ orderDetail.extra.refundReason }}
        </div>
        <div v-if="orderDetail.extra.refundProcess">
          挽单过程及补救措施：{{ orderDetail.extra.refundProcess }}
        </div>
        <div v-if="orderDetail.extra.refundConclusion">
          责任分析与经验总结：{{ orderDetail.extra.refundConclusion }}
        </div>
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        责任人信息
      </div>
      <div class="order-detail-sales">
        <div class="order-detail-people-name">
          <span>退款操作人：{{ orderDetail.editor_name }}</span>
          <span>责任人：{{ orderDetail.responsible_name }}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'OrderSigningInfo',

  props: {
    orderDetail: Object
  },
  data() {
    return {
      success_remark: '',
      fail_remark: '',
      audit_status: ''
    }
  },
  methods: {
    auditSuccess() {
      if (!this.success_remark) {
        this.$message({
          type: 'info',
          message: '请输入财务流水单号'
        })
        return
      }
      const obj = {
        order_id: this.orderDetail.order_id,
        remark: this.success_remark,
        audit_status: 'success'
      }
      this.$http.auditOrder(obj).then(() => {
        this.$emit('updateOrderList')
      })
    },
    auditFail() {
      if (!this.fail_remark) {
        this.$message({
          type: 'info',
          message: '请填写审核失败原因'
        })
        return
      }
      const obj = {
        order_id: this.orderDetail.order_id,
        remark: this.fail_remark,
        audit_status: 'fail'
      }
      this.$http.auditOrder(obj).then(res => {
        if (res.code == 200) {
          this.$emit('updateOrderList')
        }
      })
    }
  }
}
</script>

<style lang="scss">
.order-detail-dialog .el-dialog__body {
  height: 700px;
  padding: 20px 30px;
  overflow: auto;
  .order-detail-content {
    line-height: 24px;
    .order-detail-item {
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #f5f5f5;
    }
    .order-detail-status {
      padding: 15px 20px;
      background-color: #f5f5f5;
    }
    .order-detail-item-title {
      margin-bottom: 15px;
    }
    .order-detail-people-name span {
      margin-right: 30px;
    }
    .order-detail-student-name {
      width: 160px;
    }
    .el-table {
      margin-top: 10px;
    }
    .el-table tr th {
      height: 34px !important;
      background: #fff !important;
      color: #333;
    }
    .el-table td,
    .el-table th {
      padding: 4px;
      border: 1px solid #f5f5f5;
    }
  }
  .order-audit-btn {
    .el-row {
      margin-bottom: 10px;
    }
    .el-input {
      margin-right: 20px;
    }
  }
  .special-table {
    width: 100%;
    margin: 30px 0;
    border: 1px solid #f5f5f5;
    tr,
    th,
    td {
      text-align: center;
      padding: 10px 0;
      border: 1px solid #f5f5f5;
    }
  }
}
</style>
